export const CROP_BORDER = 3;
export const CROP_OUTPUT = 320; // Size of the output image
export const CROP_SIDE = CROP_OUTPUT; // Size of the crop area
export const CROP_SIZE = {
    width: CROP_SIDE,
    height: CROP_SIDE
};
export const CONTAINER_SIDE = CROP_SIDE + 2 * CROP_BORDER;
export const FILE_MAX_SIZE = 10 * 1024 * 1024;
export const FILE_VALID_TYPES = [
    'jpeg',
    'jpg',
    'png',
    'bmp'
];
export const MAX_ZOOM = 3;
